<mat-button-toggle-group value="VIEWBY"  [(ngModel)]="viewBy" >
    <mat-button-toggle value="PV" (change)="onValChange($event.value)">Current $</mat-button-toggle>
    <mat-button-toggle value="FV" (change)="onValChange($event.value)">Future $</mat-button-toggle>    
</mat-button-toggle-group>